import { Routes, Route, Navigate } from 'react-router-dom';
import SuspenseWrapper from 'components/containers/SuspenseWrapper';
import AuthCheck from 'components/AuthCheck';
import { BaseLayout } from 'components/layouts';
import Home from 'pages/Home';
import Sample from 'pages/sample/SampleTab0';
import Login from 'pages/Login';

import AdminRoute, { URL_ADMIN, URL_NON_MEMBER_JOIN } from './AdminRoute';
import BranchRoute, { URL_BRANCH } from './BranchRoute';
import SchoolRoute, { URL_SCHOOL } from './SchoolRoute';
import SptpRoute, { URL_SPTP_MANAGER } from './SptpRoute';
import PostRoute, { URL_POST } from './PostRoute';
import OrderMoniteringView from 'pages/school/order/book/OrderMoniteringView';
import NonMemberJoinCounselAdd from 'pages/NonMemberJoinCounselAdd';
import { URL_NON_MEMBER_JOIN_ADD } from './CommonRoute';
// import InitialProductRoute, { URL_INITIAL_PRODUCT,} from './InitialProductRoute';
import { getLocalStorage } from 'hooks/useLocalStorage';

export const URL_BASE = process.env.PUBLIC_URL;
export const URL_LOGIN = '/login'
export const URL_ACCOUNT_INFO = '/account';
export const URL_SAMPLE = '/sample';
export const URL_MONITERING = '/monitering/:type/:no';
export const URL_HOME = getLocalStorage('persist:user')?.level_no===1? '/admin/dashboard': getLocalStorage('persist:user')?.level_no===2? '/branch/dashboard' :'/school/member/manage';
// const SpinWrapper = styled.div`
//   text-align: center;
//   height: 100%;
//   display: flex;
//   justify-content: center;
//   flex-direction: column;
// `;

const RouterConfig = ({ common, setCommon }) => {
  return (<>
    <Routes>
      
        {/* 로그인페이지 */}
        <Route path={URL_LOGIN} element={<Login common={common} />} />
        <Route path={URL_MONITERING} element={<OrderMoniteringView common={common} />} />
        <Route 
          path={URL_NON_MEMBER_JOIN_ADD} 
          element={
            <BaseLayout sider={false} sideHide={true}>
              <SuspenseWrapper>
                <NonMemberJoinCounselAdd />
              </SuspenseWrapper>
            </BaseLayout>
          } 
        />

        {/* private 페이지 */}
        
        <Route path="/" element={<AuthCheck common={common}><BaseLayout common={common} setCommon={setCommon}></BaseLayout></AuthCheck>}>
          <Route path="/" element={<Navigate to={URL_HOME} replace={true} />}/>
          {/* <Route path={URL_HOME} element={<Home common={common} />} /> */}
          
            {/* 본사 */}
            <Route path={`${URL_ADMIN}/*`} element={<SuspenseWrapper><AdminRoute common={common} /></SuspenseWrapper>} />
            
            {/* 지사 */}
            <Route path={`${URL_BRANCH}/*`} element={<SuspenseWrapper><BranchRoute common={common} /></SuspenseWrapper>} />
            
            {/* 교육원 & 강사*/}
            <Route path={`${URL_SCHOOL}/*`} element={<SuspenseWrapper><SchoolRoute common={common} /></SuspenseWrapper>} />
            
            {/* SPTP관리자 */}
            <Route path={`${URL_SPTP_MANAGER}/*`} element={<SuspenseWrapper><SptpRoute common={common} /></SuspenseWrapper>} />

            {/* 배송관리자 */}
            <Route path={`${URL_POST}/*`} element={<SuspenseWrapper><PostRoute common={common} /></SuspenseWrapper>} />

            {/* 초도물품 관리 */}
            {/* <Route path={`${URL_INITIAL_PRODUCT}/*`} element={<SuspenseWrapper><InitialProductRoute common={common} /></SuspenseWrapper>} /> */}
            
            {/* Sample */}
            {/* <Route path={URL_SAMPLE} element={<SuspenseWrapper><Sample common={common} /></SuspenseWrapper>} /> */}
        </Route>
    </Routes>
  </>);
};


export default RouterConfig;

